// URL list
import URL from '../../../config.url'

import { getSafe } from '../../utils/Object'

export default
{
    name: 'app-menu-mobile',

    props:
    {
        content: { type: Array }
    },

    data()
    {
        return {
            pagesURL: URL.page,
            nav: null
        }
    },

    created()
    {
        const data = JSON.parse(JSON.stringify(this.content))
        const nav = []

        for (const item of data)
        {
            if (item.nav)
            {
                for (const subItem of item.nav)
                {
                    nav.push(subItem)
                }
            }
            else
            {
                nav.push(item)
            }
        }

        this.nav = nav
    },

    mounted()
    {
        this.eventHub.$emit('menu-opened', this.$el.offsetHeight)
    },

    destroyed()
    {
        this.eventHub.$emit('menu-closed')
    },

    methods:
    {
        _getPageURL(page)
        {
            return this.$root.getPageURLFromID(page.pageLabel,
                {
                    slug: getSafe(() => page.slug)
                })
        },

        _close()
        {
            this.$emit('close')
        },

        _onChange(url)
        {
            this.$root.changePage(url)
            this.$emit('close')
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-menu-mobile/script.js